import { render, staticRenderFns } from "./customer-data-v2.vue?vue&type=template&id=583a0b91"
import script from "./customer-data-v2.vue?vue&type=script&lang=js"
export * from "./customer-data-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports